import { FormErrors } from 'redux-form';

interface IDpsDeclaration {
  dpsDeclaration: string;
}

const validation = (values: IDpsDeclaration) => {
  const errors: FormErrors<any> = {};

  if (!values.dpsDeclaration) {
    errors.dpsDeclaration = 'Debe seleccionar alguna opción';
  }

  return errors;
};

export default validation;
